module.exports = "https://99designs-start-assets.imgix.net/js/0ed93eaed817d6475a63a7810d2874c1.png";